import { render, staticRenderFns } from "./pendingOrders.vue?vue&type=template&id=145552de"
import script from "./pendingOrders.vue?vue&type=script&lang=js"
export * from "./pendingOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports